module.exports = __webpack_public_path__ + "img/campaign.f390d66b.svg";